// Returns whether the in-progress application form has anything worth losing.
// `date` is prefilled by default and deliberately excluded — it alone does not make the form dirty.
export function isApplicationDirty({ resume, fileName, jobDescription, applicationInfo, applicationSource, documents }) {
  if (resume?.trim() || fileName) return true;
  if (jobDescription?.trim()) return true;
  const infoDirty = Object.entries(applicationInfo || {}).some(
    ([key, value]) => key !== 'date' && value?.trim?.()
  );
  if (infoDirty) return true;
  const sourceDirty = Object.values(applicationSource || {}).some(
    (src) => src?.selected || src?.text?.trim()
  );
  if (sourceDirty) return true;
  return (documents || []).some((doc) => doc.selected);
}

// Resets the in-progress application form back to a genuinely blank state.
// Mirrors the shape of Layout.js's handleLoadDemo, aimed at blank values instead of demo data.
// React state only — no Supabase calls, does not touch the saved resume vault.
export function resetApplicationState({
  setResume,
  setFileName,
  setResumePreloaded,
  setResumeSavedAt,
  setJobDescription,
  setApplicationInfo,
  setApplicationSource,
  setDocuments,
  setResultsView,
  setResults,
  setResult,
  setFixStates,
  setLoadingDocs,
  setGeneratedLanguage,
  setError,
  setSaveStates,
  setTone,
}) {
  setResume('');
  setFileName(null);
  setResumePreloaded(false);
  setResumeSavedAt(null);
  setJobDescription('');
  setApplicationInfo({
    date: new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }),
    company: '',
    targetJobTitle: '',
    hiringManager: '',
    title: '',
    address: '',
  });
  setApplicationSource({
    jobDescription: { selected: false, text: '' },
    service: { selected: false, text: '' },
    industry: { selected: false, text: '' },
    role: { selected: false, text: '' },
    company: { selected: false, text: '' },
    other: { selected: false, text: '' },
  });
  setDocuments([
    { type: 'resume', selected: false, style: 'Professional / Corporate', audience: 'ATS / Human' },
    { type: 'cv', selected: false, style: 'Professional / Corporate', audience: 'ATS / Human' },
    { type: 'coverLetter', selected: false, style: 'Professional / Corporate', audience: 'ATS / Human' },
    { type: 'linkedin', selected: false, style: 'Professional & Polished', audience: 'ATS / Human' },
    { type: 'bio', selected: false, style: 'Professional & Polished', audience: 'ATS / Human' },
    { type: 'portfolio', selected: false, style: 'Bold & Creative', audience: 'ATS / Human' },
  ]);
  setResultsView(false);
  setResults([]);
  setResult(null);
  setFixStates({});
  setLoadingDocs({});
  setGeneratedLanguage(null);
  setError(null);
  setSaveStates({});
  setTone('Professional');
}
